import React, { useState, useEffect, useRef, useCallback } from "react";
import Icon from "../../../icons";
import Avatar from "react-avatar";

const RemoveUserModal = (props) => {
  const { onCancelPress, onHandleRemoveAccess } = props;
  return (
    <div className="modal">
      <div className="modalContent small">
        <div className="modalHeader rowSpaceBetween alignMiddle">
          <h1>Remove User</h1>
          <Icon name="close" className="icon close" onClick={onCancelPress}/>
        </div>
        <div className="modalBody">
          <div className="org_access__add--user">
            <div className="formGroup mrNone">
              <div className="search rowFlex">Are you sure you want to remove this user?</div>
            </div>
          </div>
        </div>
        <div className="modalFooter">
          <button className="btn-cc__danger" onClick={onHandleRemoveAccess}>
            Remove Access
          </button>
          <button className="btn-cc__link" onClick={onCancelPress}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveUserModal;
